






































import { Component, Prop, Vue } from 'vue-property-decorator'
import { GamePlayer } from '@/class/gamePlayer'
import { Game } from '@/class/game'
import { GameState } from '@/enum'
import Card from '@/components/Common/Card/Card.vue'
import VoteLog from '../VoteLog.vue'
import NightVoteLog from '../NightVoteLog.vue'
import NightActionResult from '../../nightActionResult/NightActionResult.vue'
import TakeOtherResultMessages from '../TakeOtherResultMessages.vue'
import FirstNight from './FirstNight.vue'

@Component({
  components: {
    Card,
    VoteLog,
    NightVoteLog,
    NightActionResult,
    TakeOtherResultMessages,
    FirstNight,
  }
})
export default class GameStateLog extends Vue {
  @Prop() game!: Game;
  @Prop() playerSelf?: GamePlayer;

  get state () {
    return this.game.gameState
  }

  getMessage () {
    const actionFollowMessage: {[key: string]: string} = {
      [GameState.firstNight]: '',
      [GameState.day]: '議論を行い怪しい人物を探してください',
      [GameState.voteStart]: '投票対象を選択してください',
      [GameState.voteEnd]: '',
      [GameState.finalVoteReady]: '',
      [GameState.finalVoteStart]: '投票対象を選択してください',
      [GameState.takeOther]: this.takeOtherFollowMessage,
      [GameState.night]: this.nightActionFollowMessage
    }
    return actionFollowMessage[this.game.gameState]
  }

  get nightActionFollowMessage () {
    if (!this.playerSelf || !this.playerSelf.roleId || this.playerSelf.isDead) {
      return ''
    }
    if (this.playerSelf.role.activeIn[GameState.night]) {
      return this.playerSelf.role.nightActionFollowMessage
    } else {
      return '怪しいと思う人物を一人選んでください。'
    }
  }

  get takeOtherFollowMessage () {
    if (this.playerSelf && this.playerSelf.takeOther) {
      return this.playerSelf.role.takeOtherFollowMessage
    } else {
      return '道連れ選択中です。時間までお待ちください。'
    }
  }

  get finalVoteTalkerId () {
    return this.game.finalVoteTalkerId
  }

  get finalVotePlayerName () {
    return this.game.getGamePlayer(this.game.finalVoteTalkerId).name
  }

  get roomStateLabel (): string {
    return this.game.stateLabel
  }

  get isFullclose () {
    return this.game.settings.isFullclose
  }

  get playerId () {
    return this.playerSelf?.id
  }
}
